// src/features/projectInfoSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { IBasicInfo } from "../../modules/project/components/dark_version/ProjectDetails/ProjectBasicInfo";
import { IFinancialStatus } from "../../modules/project/components/dark_version/ProjectDetails/FinancialStatus";
import { ITeam } from "../../modules/project/components/dark_version/ProjectDetails/ProjectTeam";
import { IProjectComponent } from "../../modules/project/components/dark_version/ProjectDetails/ProjectTimeline";
import { IPhysicalStatus } from "../../modules/project/components/dark_version/ProjectDetails/PhysicalStatus";

const defaultBasicInfo: IBasicInfo = {
  title: "",
  region: "",
  donor: "",
  exec_agency: "",
  description: "",
  signing_date: "",
  closing_date: "",
};
const defaultFinancialStatus: IFinancialStatus = {
  cost: 0,
  foreign: 0,
  local: 0,
  additional_financing: 0,
  disbursement: [],
  withdrawal: [],
  acum_spending: [],
};

interface IState {
  pid: number;
  financialProgress: number;
  physicalProgress: number;
  donorFund: number;
  adpShare: number;
  basicInfo: IBasicInfo;
  title: string;
  financialStatus: IFinancialStatus;
  teams: ITeam[];
  projectComponents: IProjectComponent[];
  years: number[];
  physicalStatus: IPhysicalStatus | null;
}

const initialState: IState = {
  pid: -1,
  financialProgress: 0,
  physicalProgress: 0,
  donorFund: 0,
  adpShare: 0,
  basicInfo: defaultBasicInfo,
  title: "",
  financialStatus: defaultFinancialStatus,
  teams: [],
  projectComponents: [],
  years: [],
  physicalStatus: null,
};

const projectInfoSlice = createSlice({
  name: "projectInfo",
  initialState,
  reducers: {
    setPid: (state, action) => {
      state.pid = action.payload.pid;
    },
    setProgress: (state, action) => {
      state.pid = action.payload.pid;
      state.financialProgress = action.payload.financialProgress;
      state.physicalProgress = action.payload.physicalProgress;
      state.adpShare = action.payload.adpShare;
      state.donorFund = action.payload.donorFund;
    },
    setBasicInfo: (state, action) => {
      state.basicInfo = action.payload;
    },
    setTitle: (state, action) => {
      state.title = action.payload;
    },
    setFinancialStatus: (state, action) => {
      state.financialStatus = action.payload;
    },
    setTeams: (state, action) => {
      state.teams = action.payload;
    },
    setProjectComponents: (state, actions) => {
      state.projectComponents = actions.payload.components;
      state.years = actions.payload.years;
    },
    setPhysicalStatus: (state, actions) => {
      state.physicalStatus = actions.payload;
    },
  },
});

export const projectInfoActions = projectInfoSlice.actions;

export const projectInfoReducer = projectInfoSlice.reducer;
